module.exports = __webpack_public_path__ + "assets/img/NPC042.dbdfdc0d.png";